export const ReminderTypes = {
  Create: 'create',
  Second: 'second',
  Before: 'before',
  After: 'after',
} as const;
